import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    escapeValue, mergeList, getStyle, getOffset, getIEVersion
} from './util';

const styleList = ['width', 'borderWidth', 'borderStyle', 'outline', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'height', 'paddingLeft', 'paddingTop', 'fontSize', 'wordWrap', 'fontFamily', 'lineHeight', 'overflowX', 'overflowY'];
/*
    获取textarea中@的坐标，通过复制一个div，样式和textarea保持一致，通过<span>@</span>方式获取span的坐标
*/
class TextareaCopyer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            before: '',
            after: '',
            flag: ''
        };
        this.getListOffset = this.getListOffset.bind(this);
    }

    getListOffset(nextProps) {
        const { textarea, index } = nextProps || this.props;
        const value = textarea.value;

        const beforeCont = escapeValue(value.substr(0, index)).replace(/\n/g, '<br/>').replace(/\s/g, '<span class="j-test" style="display:inline-block;white-space: pre-wrap; font-family:Arial, Helvetica, sans-serif;"> </span>');
        // var _test = _e._$getByClassName(this.__before, 'j-test');
        // for(var _i = 0; _i < _test.length; _i++){
        //     _test[_i].innerText = ' ';
        // };
        const flagCont = value.charAt(index);
        const afterCont = escapeValue(value.substr(index + 1, value.length));
        this.setState({
            before: beforeCont,
            after: afterCont,
            flag: flagCont
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.index != this.props.index) {
            this.getListOffset(nextProps);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { textarea, index } = this.props;
        const { before, after, flag } = this.state;
        if (nextProps.textarea == textarea && nextProps.index == index && nextState.before == before && nextState.after == after && nextState.flag == flag) {
            return false;
        }
        return true;
    }

    copyStyle() {
        const { textarea } = this.props;
        const hstyle = {};
        for (let i = 0, len = styleList.length; i < len; i++) {
            if (styleList[i] === 'width' && getStyle(textarea, styleList[i]) == '100%') {
                hstyle[styleList[i]] = `${textarea.offsetWidth}px`;
                continue;
            }
            hstyle[styleList[i]] = getStyle(textarea, styleList[i]);
        }
        return hstyle;
    }

    componentDidUpdate() {
        const { textarea, index, onChangeOffset } = this.props;
        // console.log(textarea, index, onChangeOffset);
        let flagOffset;
        let eleOffset;
        let offsetY;
        const flagEle = this.refs.flag;
        offsetY = parseInt(getStyle(textarea, 'lineHeight'));
        flagOffset = getOffset(flagEle, flagEle.parentNode);
        eleOffset = getOffset(textarea);
        const x = flagOffset.x + eleOffset.x;
        const y = flagOffset.y + eleOffset.y + offsetY;
        onChangeOffset && onChangeOffset({ x, y });
    }

    render() {
        const { textarea, index } = this.props;
        const { before, after, flag } = this.state;
        let style;
        if (textarea) {
            style = this.copyStyle();
        }
        // console.log(index, 'before==', before);
        // console.log(index, 'after==', after);
        // console.log(index, 'flag==', flag);
        return (
            <div style={style} className="u-at_copyer">
                {before != '' ? (<span ref="before" dangerouslySetInnerHTML={{ __html: before }} />) : (<span ref="before" />)}
                {flag != '' ? (<span ref="flag" dangerouslySetInnerHTML={{ __html: flag }} />) : (<span ref="flag">@</span>)}
                {after != '' ? (<span ref="after" dangerouslySetInnerHTML={{ __html: after }} />) : (<span ref="after" />)}
            </div>
        );
    }
}
TextareaCopyer.propTypes = {
    textarea: PropTypes.any,
    index: PropTypes.number,
    onChangeOffset: PropTypes.func
};
export default TextareaCopyer;



// WEBPACK FOOTER //
// ./client/component/at/copy.js